export class ReportCompanyHieracyDTO{
  public ParentRelationId : number;
  public Azienda: string;
  public Livello: string;
  public AziendaLiv1 : string;
  public AziendaLiv2 : string;
  public AziendaLiv3 : string;
  public Email : string;
  public VatNumber : string;
  public LicencesAvailable: string;
  public Enabled: boolean;
  public FK_Company: number;
  public IDAziendaLiv1: number;
}

export class ReportGenericCompanyDTO {
  public IDLegalEntity: number;
  public IDCliente: number;
  public Denominazione: string;
  public PartitaIva: string;
  public Rivenditore: string;
  public Tipo: string;
  public DataAttivazione: Date;
  public DataDisattivazione: Date;
  public CountUtenti: number;
  public Email: string;
  public Telefono: string;

}

export class ReportInvoiceCompanyDTO{
  public IDCliente: number;
  public Denominazione: string;
  public PartitaIva: string;
  public Anno: number;
  public Mese: number;
  public CountInvoice: number;
  public TipoProdotto: string;
  public TipoFattura: string;
  public CategoriaFattura: string;
}

export class ReportInvoiceCompanyFilterDTO {
  public AnnoRiferimento: number;
  public FattureProduct: string;
  public FattureCategory: string;
}



